<template>
  <div class="background info">
    <vue-headful :title="doctitle" />
    <div class="">
      <img
        class="rectangle-red"
        id="red-1"
        src="https://res.cloudinary.com/oredev/image/upload/v1679663725/2023_web/shapes%20info/Red-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green"
        id="green-1"
        src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
        alt="rectangle"
      />

      <b-container class="headline-container">
        <b-row>
          <b-col xl="1"></b-col>
          <b-col>
            <b-row class="row">
              <b-col sm="12" lg="8">
                <h1 class="text-dark">CONFERENCE INFORMATION</h1>
                <h1 class="text-dark">
                  DETAILS YOU MIGHT BE WONDERING ABOUT
                </h1></b-col
              >
            </b-row>

            <b-row no-gutters class="pt-5">
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-end justify-content-lg-center"
              >
                <a
                  href="#flight"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    fluid
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207774/2022_web/Flight_cnkozt.svg"
                  ></b-img>
                  <p class="text-color-light">Flight</p>
                </a>
              </b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-start justify-content-lg-center"
              >
                <a
                  href="#price"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    fluid
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207785/2022_web/Prices_zjri4d.svg"
                  ></b-img>
                  <p class="text-color-light">Prices</p>
                </a>
              </b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-end justify-content-lg-center"
              >
                <a
                  href="#hotel"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    src="https://res.cloudinary.com/oredev/image/upload/v1685948437/2023_web/Hotel-off-white_2.svg"
                  ></b-img>
                  <p class="text-color-light">Hotel</p>
                </a>
              </b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-start justify-content-lg-center"
              >
                <a
                  href="#food"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207775/2022_web/Food_h0vega.svg"
                  ></b-img>
                  <p class="text-color-light">Food</p>
                </a>
              </b-col>
              <b-col lg="4"></b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-end justify-content-lg-center"
              >
                <a
                  href="#language"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207790/2022_web/Web_w5cetn.svg"
                  ></b-img>
                  <p class="text-color-light">Language</p>
                </a>
              </b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-start justify-content-lg-center"
              >
                <a
                  href="#parking"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207782/2022_web/Parking_gnwpro.svg"
                  ></b-img>
                  <p class="text-color-light">Parking</p>
                </a>
              </b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-end justify-content-lg-center"
              >
                <a
                  href="#luggage"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207780/2022_web/Luggage_yb0rxj.svg"
                  ></b-img>
                  <p class="text-color-light">Luggage</p>
                </a>
              </b-col>
              <b-col
                lg="2"
                cols="6"
                class="d-flex justify-content-start justify-content-lg-center"
              >
                <a
                  href="#wifi"
                  class="bg-color-dark m-2 m-sm-2 icons"
                  style="text-decoration: none !important"
                >
                  <b-img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207791/2022_web/Wifi_db3vsn.svg"
                  ></b-img>
                  <p class="text-color-light">Wifi</p>
                </a>
              </b-col>

              <!--   <div class="icons-container">
                  
                 
                 
                 
                </div>
                <div class="icons-container">
                 
                 
                  
                 
                </div> -->
            </b-row>
          </b-col>

          <b-col xl="1"></b-col>
        </b-row>
        <b-row id="travel">
          <b-col xl="1"></b-col>

          <b-col lg="5" sm="12" class="mt-5 pt-2 pt-md-5">
            <h1>Malmö</h1>
            <p class="text-dark">
              Malmö is the hub of the Skåne region, Sweden’s third largest city
              and the commercial centre of southern Sweden. Approximately
              318.107 people live in Malmö at the centre of the new Øresund
              Region with around 3.5 million inhabitants. The Danish capital
              Copenhagen is less than half an hour away and connected to Malmö
              by a convenient bridge which opened in 2000.
            </p>
            <p class="text-dark">
              Malmö City tourist website:
              <a href="http://www.malmo.se/tourist" target="_blank"
                >www.malmo.se/tourist</a
              >
            </p>
            <p class="">
              The center of Malmö is situated only 20 minutes by train from
              Copenhagen Airport in Denmark.
            </p>
            <p class="">
              The airport is connected to Malmö by the Øresund Bridge and trains
              run around the clock between Hyllie/Triangeln/Malmö C and the
              airport.
            </p>
          </b-col>
          <b-col lg="5" sm="12">
            <div class="d-flex justify-content-center">
              <img
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1679601593/2023_web/Malmo%CC%88-illustration-with-grain.png"
                alt=""
                style="max-height: 600px"
              />
            </div>
          </b-col>
          <b-col xl="1"></b-col>
        </b-row>
      </b-container>
    </div>

    <div class="bg-color-dark position-relative">
      <!-- RED RECTANGLES -->

      <img
        class="rectangle-red"
        id="red-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1679663725/2023_web/shapes%20info/Red-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-red"
        id="red-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1679663725/2023_web/shapes%20info/Red-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-red"
        id="red-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1679663725/2023_web/shapes%20info/Red-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-red-short"
        id="red-5"
        src="https://res.cloudinary.com/oredev/image/upload/v1679902493/2023_web/shapes%20info/Red-shape-3.png"
        alt="rectangle"
      />
      <img
        class="rectangle-red-short"
        id="red-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1679902493/2023_web/shapes%20info/Red-shape-3.png"
        alt="rectangle"
      />
      <!-- GREEN RECTANGLES -->
      <img
        class="rectangle-green-short"
        id="green-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short"
        id="green-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short"
        id="green-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short"
        id="green-5"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short"
        id="green-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short"
        id="green-7"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green"
        id="green-8"
        src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />

      <!-- WHITE SHAPES -->
      <img
        class="d-none d-xl-block"
        id="white-1"
        src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
        alt="rectangle"
      />
      <img
        id="white-2"
        class="d-none d-xl-block"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088000/2023_web/shapes%20info/white-shape-4.png"
        alt="rectangle"
      />
      <img
        class="d-block d-md-none"
        id="white-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088576/2023_web/shapes%20info/white-shape-6.png"
        alt="rectangle"
      />
      <img
        class="d-block d-sm-none"
        id="white-5"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088704/2023_web/shapes%20info/White-shape-1.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088883/2023_web/shapes%20info/white-shape-8.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-7"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-8"
        src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-9"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-10"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088883/2023_web/shapes%20info/white-shape-8.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-11"
        src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-12"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block"
        id="white-13"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />
      <b-container>
        <b-row>
          <b-col sm="12" md="8" offset-md="2">
            <div class="pink pt-5 pb-3 mt-5">
              <h2 class="text-color-light">WHERE &amp; WHEN</h2>
              <p class="text-color-light">
                The Øredev conference and workshops will be held at Malmö
                Mässan, Exhibition & Conference Center, located in Malmö Sweden,
                one station away (Hyllie station) from the Copenhagen airport.
              </p>
              <p class="text-color-light">
                Workshops are hosted at a separate venue; if you're attending a
                workshop at Øredev this year, you'll receive all relevant
                information directly.
              </p>

              <p class="text-color-light">
                Conference days: Wednesday 8th Nov – Friday 10th Nov
              </p>

              <div class="pt-4">
                <p>
                  <!-- <strong class="text-color-light font-weight-bolder"
                  
                  >
                  <span class="text-color-light"
                    ><br /> -->
                </p>
              </div>
              <!-- <img class="mt-5 mb-5" src="/static/map/map.png" alt="" /> -->
            </div>

            <div class="pt-3 pb-3">
              <h3 class="mt-1 text-color-light">
                What are the days and opening hours?
              </h3>
              <div class="pt-3">
                <div class="d-flex align-items-center">
                  <img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207770/2022_web/Clock-2_fx1y0l.svg"
                    alt=""
                    style="width: 10%"
                  />
                  <p class="text-color-light">Conference days start 07:30</p>
                </div>
                <div class="d-flex align-items-center">
                  <img
                    src="https://res.cloudinary.com/oredev/image/upload/v1648207769/2022_web/Clock-1_sfqgzo.svg"
                    alt=""
                    style="width: 10%"
                  />
                  <p class="text-color-light">
                    Conference days end 20:00-22:00
                  </p>
                </div>
              </div>

              <div class="pt-2 text-color-light">
                <p>
                  Opening hours
                  <br />
                  Wednesday 8th Nov, Conference: 07:30-19:00
                  <br />
                  Thursday 9th Nov, Conference: 07:30-22:30
                  <br />
                  Friday 10th Nov, Conference: 07:30-13:00
                </p>
              </div>
            </div>

            <div id="wifi" class="mt-5 pt-3 pb-3 bg-color-dark infobox">
              <h3 class="text-color-light mt-5">Wifi</h3>
              <p class="">
                There is Wi-Fi available throughout the venue, but its speed
                varies with the number of users. If your carrier is local to the
                region, it will result in a faster connection for everyone if
                you access the world wide web via 4G. Thanks!
              </p>
              <!--  <img
              class="mt-5 mb-5 strange-o"
              src="https://res.cloudinary.com/oredev/image/upload/2019/html/strange-o.png"
              alt=""
            /> -->
              <!--   <h3 class="mt-5">THE STRANGE LETTER Ø</h3>
            <p>
              If you don’t have the character Ø on your keyboard it’s a little
              bit tricky to type Øredev. But if you know that the Unicode is
              00D8 - then it will be much easier. On Windows XP you just hold
              the Alt-key down and type 0216 and release the Alt-key. If you
              want to know more about Unicode 00D8;
              <a href="https://en.wikipedia.org/wiki/%C3%98" target="_blank"
                >click here</a
              >.
            </p> -->
            </div>

            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Charge your mobile</h3>
              <p class="">
                The luggage storage and info booth facility offers the
                possibility to recharge your mobile phone. Bring your charger!
              </p>
              <!--   <p class="charger green">
              <i class="material-icons rotate-90">battery_charging_full</i>
              Bring your charger!
              <i class="material-icons rotate-90">battery_charging_full</i>
            </p> -->
            </div>

            <div id="food" class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 id="food" class="text-color-light">
                You will be served good food!
              </h3>
              <p class="">
                You will be served a light breakfast in the mornings, lunch
                every day (except on Friday, Nov 10th, when we wrap up Øredev at 1pm), and a vegetarian dinner on Thursday 9th of November (with vegan
               options). Our food is mostly dairy and gluten
                free. If you have any allergies or diet restrictions, please
                inform us as soon as possible at:
                <a href="mailto:info@oredev.org">info@oredev.org</a>. Coffee,
                tea, water and fruits are available all day and soda and sweets
                in the afternoon. Do not hesitate to contact us if you have
                questions.
              </p>
            </div>

            <!--    <div id="luggage" class="pt-3 pb-3 bg-color-dark infobox mt-5">
            <h3 class="text-color-light">Free luggage storage</h3>
            <p class="">
              You will find free and secure storage facilities at the entrance
              of the conference hall. Here you can store common items, such as
              overcoats, backpacks or suitcases. The luggage storage facility
              does not store money and cannot be held responsible for more
              valuable items.
            </p>
          </div> -->

            <div id="luggage" class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Free Luggage Storage</h3>
              <p class="">
                You will find free and secure storage facilities at the entrance
                of the conference hall. Here you can store common items, such as
                overcoats, backpacks or suitcases. The luggage storage facility
                does not store money and cannot be held responsible for more
                valuable items.
              </p>
            </div>

            <div id="language" class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Language</h3>
              <p class="">
                The official language of the conference is English.
              </p>
            </div>

            <div id="flight" class="pt-3 pb-3 infobox mt-5">
              <h3 class="mt-5 text-color-light">Can I fly to Malmö?</h3>
              <p class="text-color-light">
                We recommend you use the Copenhagen Airport which is served by
                more than 60 carriers, operating services to and from 125 cities
                world-wide. The airport is connected to Malmö by the Øresund
                Bridge and trains run around the clock between the airport and
                the city center. Take the train at the airport and 11 minutes
                later you will find yourself in the heart of Malmö-Hyllie, and a
                3 minutes walk from the venue.
              </p>

              <a
                href="https://www.google.com/maps/d/u/0/embed?mid=1AiWR-YSP88h-yiyBdo3TLXW2lzg"
                target="_blank"
              >
                <img
                  class="map-region mt-4 d-none d-sm-block"
                  src="https://res.cloudinary.com/oredev/image/upload/2019/html/map-region.jpg"
                  alt=""
                />
                <img
                  class="map-region mt-4 d-block d-sm-none"
                  src="https://res.cloudinary.com/oredev/image/upload/v1680864402/2023_web/Screenshot_2023-03-08_at_10.07_1_2x.png"
                  alt=""
                />
              </a>

              <h3 class="mt-5 text-color-light">Coming from Denmark?</h3>
              <p class="">
                The conference venue is located in Hyllie, which is the first
                stop after Copenhagen Airport. It has never been as easy to
                reach us!
              </p>
            </div>
            <div id="luggage" class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">What should I bring?</h3>
              <p class="">
                Some workshops require the use of a laptop, we will inform you
                about what you should bring. We advise you to bring a reusable
                water bottle ♻️ to reduce the use of single use cups. During the
                conference, we will provide you with paper and pen to take notes
                and enough food and coffee to survive!
              </p>
            </div>
            <div id="parking" class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Parking</h3>
              <p>
                Close to Malmömässan there are a lot of parking spaces and
                further more in the neighbourhood. The parking ATMs accept only
                credit card. There are also a lot of Parking apps that you can
                use, EasyPark and Parkster. The parking is run by Parkering
                Malmö or Q-park.
                <a
                  href="https://karta.pmalmo.se"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  See the closet parking on this map</a
                >
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">For those in need</h3>
              <p class="">
                The conference hall is fully accessible to disabled persons and
                equiped with a hearing loop system, in addition, arrangements
                include the possibility of bringing helpers to the conference,
                please <a href="mailto:info@oredev.org">contact us</a>. If you
                need to use the hearing loop system. Just
                <a href="mailto:maisa@oredev.org">let us know</a> if you need to
                use it and we will let you know how to use it!
              </p>
            </div>

            <div class="pt-3 pb-3 infobox mt-5">
              <h3 class="text-color-light">Electricity</h3>
              <p class="">
                The electrical current in Sweden is 220V/50 Hz. Round, european
                style two-pin plugs are used. Appliances designed to operate in
                110/120 V need a voltage converter and a plug adapter.
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Shopping</h3>

              <p class="">
                The conference hall is located across the street from one of
                Scandinavia's biggest shopping mall
                <a href="https://emporia.steenstrom.se">Emporia</a>. There is
                even an Apple Store there! In Malmö city the stores are
                generally open between 9.00 am and 6.00 pm on weekdays and
                between 10.00 am and 5.00 pm on weekends. Some department stores
                stay open until 8.00 pm daily.
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Disclaimer & insurance</h3>
              <p class="">
                Øredev accepts no liability for any injuries/losses incurred by
                participants and/or accompanying persons, nor loss or damage to
                any luggage and/or personal belongings. Participants are advised
                to take out their own personal insurance.
              </p>
            </div>
            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Passports & visas</h3>
              <p class="">
                Participants are advised to make their own arrangements with
                respect to entering Sweden. Participants who require an
                invitation -in order to get a visa- will receive it after
                payment of the conference fee.
              </p>
            </div>

            <div class="pt-3 pb-3 infobox mt-5">
              <div class="">
                <h3 id="price" class="text-color-light">Prices</h3>
                <p class="text-color-light">
                  Choose a 1, 2, or 3 Conference Pass or 1 day workshop and
                  choose which day(s) you will attend when you register. The
                  workshop seats are limited so you have to choose them when you
                  register.
                </p>
                <p class="mt-3 price-info">
                  The prices are in Swedish crown (SEK) and exclusive of V.A.T.
                </p>
              </div>
              <table class="register mt-4 mb-3">
                <tbody>
                  <tr>
                    <th></th>
                    <th class="text-color-light">1 day-<br /></th>
                    <th class="text-color-light">2 days-<br /></th>
                    <th class="text-color-light">3 days-<br /></th>
                    <th class="text-color-light">3 days + Hotel<br /></th>
                  </tr>
                  <tr class="text-color-light">
                    <td>Blind Bird <br /></td>
                    <td>/<br /></td>
                    <td>/<br /></td>
                    <td>10 000<br /></td>
                    <td>13 897</td>
                  </tr>
                  <tr class="text-color-light">
                    <td>Early Bird <br /></td>
                    <td>/<br /></td>
                    <td>/<br /></td>
                    <td>12 000<br /></td>
                    <td>15 897</td>
                  </tr>
                  <tr class="text-color-light">
                    <td>Regular <br /></td>
                    <td>9 900 <br /></td>
                    <td>11 900<br /></td>
                    <td>14 900</td>
                    <td>18 797<br /></td>
                  </tr>
                  <tr class="text-color-light">
                    <td>Late bird <br /></td>
                    <td>11 000<br /></td>
                    <td>13 000<br /></td>
                    <td>16 000</td>
                    <td>19 897<br /></td>
                  </tr>
                </tbody>
              </table>
              <div class="pt-3 pb-3">
                <p class="text-color-light">
                  The buddies-offer is the best deal - Book your ticket with a
                  friend or colleague, share hotel room with separated beds and
                  split the cost of the hotel!
                </p>
              </div>
            </div>

            <div class="pt-3 pb-3 mt-5 infobox">
              <h3 class="text-color-light">Basics</h3>

              <p>
                Keep hydrated: Use the fountains at the venue to fill your
                bottle and drink plenty of water.
                <br />
                <br />
                We go on until late: On the evening of Thursday the 9th Nov,
                we'll have entertainment, dinner will be served and we party!
                <br />
                <br />
                Be kind: Keep an open mind, it's the way to learn. Be nice to
                others, stay present. Have fun!
                <br />
                <br />
                Times like these: Each talk is 40 mins long with the exception
                of keynotes, these are 60 mins. Workshops are 120 mins.
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Payment options</h3>
              <p>
                All prices are in Swedish Crown (SEK) and excl. VAT. If you
                don't choose to pay by credit card, we will invoice your
                company/organization after your registration. Our payment terms
                are 30 days from the invoice date.
              </p>
            </div>
            <div id="hotel" class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">Hotel</h3>
              <p>
                We have a partnership with Malmö Arena Hotel, which is located
                across the street from the venue. The 3-day conference pass
                includes 3 nights in a standard room. Including wifi, breakfast
                and access to their gym. Check-in Tuesday from 15:00, check-out
                Friday before 11:00.
                <br />
                <br />
                When you buy a ticket including hotel, Öredev AB is responsible
                for the hotel booking and no direct booking with the hotel is
                necessary from you as a participant.
              </p>
            </div>

            <div
              id="cancellation"
              class="pt-3 pb-3 text-color-light infobox mt-5"
            >
              <h3 class="text-color-light">Cancellation policy</h3>
              <p>
                Please note that once the registration has been made and the
                confirmation email has been sent out, the registration fee and
                the hotel is non-refundable. In case of illness or unforeseen
                circumstances, ticket(s) can be transferred to a colleague
                without any charge, just contact us at
                <a href="mailto:info@oredev.org">info@oredev.org</a>.
              </p>
              <p>
                In case there is not a sufficient number of registrations for a
                particular workshop, we reserve the right to cancel it one week
                prior to the conference. If a workshop is cancelled registered
                attendees will be contacted directly and they can register for
                another training or get a refund.
              </p>
              <p>
                Öredev AB will carry out the event with respect to participants’
                health and follow current restrictions and regulations from the
                Public Health Agency of Sweden. You can get a full refund if we
                postpone or cancel the event or have to limit the number of
                participants. You can as well get a full refund because of
                national or international restrictions or state enforced
                quarantine.
              </p>
              <p>
                We will inform you if there are any requirements to attend the
                event (like the presentation of a proof of vaccine etc). If you
                cannot fulfil the requirements on the day of the event, the
                organiser has the right to deny you access to the event.
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark text-color-light infobox mt-5">
              <h3 class="text-color-light">VAT</h3>
              <p class="">
                According to Swedish regulations from Skatteverket, we must
                charge Swedish VAT on the ticket price (25%) and the hotel price
                (12%) to all attendees, both Swedish and International
                companies.
              </p>
              <br />
              <p class="">
                Please or Skatteverket directly if you have any concerns about
                this regulation. Please
                <a href="mailto:info@oredev.org">contact us</a> r Skatteverket
                directly if you have any concerns about this regulation.
              </p>
              <br />
              <p>
                The regulations from the EU Commission states that
                <a
                  href="https://www4.skatteverket.se/rattsligvagledning/edition/2019.4/329381.html#update_20190502080059"
                  target="_blank"
                  >Article 53</a
                >
                in the VAT directive should be interpreted so that the term
                ”Access to events” includes a service of a five days course in
                accounting, which is only provided to taxable persons and which
                requires registration and payment to be made in advance.
                Taxation country is the country where the course takes place and
                this applies regardless of who the buyer is.
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark text-color-light infobox mt-5">
              <h3 class="text-color-light">Group discount</h3>
              <div class="row mt-3 mb-4">
                <div class="col-sm-12 col-lg-6 p-0">
                  <p class="text-color-light pl-3">10 participants</p>
                  <p class="text-color-light pl-3">10% Discount</p>
                </div>
                <div class="col-sm-12 col-lg-6 p-0">
                  <p class="text-color-light pl-3">Over 10 Participants</p>
                  <p class="text-color-light pl-3">15% Discount</p>
                </div>
              </div>

              <p class="mt-5">Register 10 participants and get 10% discount.</p>
              <br />
              <p>
                Register over 10 participants and get 15% discount and the
                opportunity to have a small booth on the exhibition floor + your
                logo on our website, listed as “Best Company”. It is our way to
                recognise the companies taking seriously care of their
                employees’ competence development.
              </p>
              <br />
              <p class="mb-5">
                (The group discount is only valid on regular tickets (1-Day, 2-Days and 3-Days Conference Passes), and only on
                the ticket price.)
              </p>
            </div>

            <div class="pt-3 pb-3 bg-color-dark infobox mt-5">
              <h3 class="text-color-light">
                We wish you an excellent stay in Malmö
              </h3>
              <p>
                If you didn’t find an answer to your question here, please send
                your request to:
                <a href="mailto:info@oredev.org">info@oredev.org</a>
              </p>
              <!--     <div class="mt-5 video-container">
              <iframe
                src="https://player.vimeo.com/video/191121225?autoplay=0&amp;loop=1&amp;color=ffffff"
                frameborder="0"
                webkitallowfullscreen=""
                mozallowfullscreen=""
                allowfullscreen=""
              ></iframe>
            </div> -->
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { tagsMixin } from "../mixins/tagsMixin";
import SvgMadhatter from "../components/Svg/SvgMadhatter.vue";
import MultiArrow2Small from "../components/Svg/MultiArrow2Small.vue";
import SvgRedArrow from "../components/Svg/SvgRedArrow.vue";
import Gallery from "../components/Gallery.vue";

export default {
  name: "faq",
  components: {
    SvgMadhatter,
    MultiArrow2Small,
    SvgRedArrow,
    Gallery,
  },
  mounted() {
    this.$nextTick(() => {
      const el = document.querySelector(this.$route.hash);
      el && el.scrollIntoView();
    });
  },
  data() {
    return {
      doctitle: "Info - " + this.$store.state.conferencename,
    };
  },
  //mixins: [tagsMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only --->
<style lang="scss" scoped>
@import "../styles/variables.scss";

h3 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 20px;
  font-weight: 700;
}

.background {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1681929225/2023_web/Bg-Landing-page-latest.png");
  background-repeat: no-repeat;
  background-position: top;

  background-size: contain;
}
.headline-container {
  padding-top: 150px;
}

@media screen and (min-width: 1000px) {
  .background {
    background-position: top;
    background-size: contain;
  }
}
@media screen and (max-width: 991px) {
  .background {
    background: url("https://res.cloudinary.com/oredev/image/upload/v1681929225/2023_web/Bg-Landing-page-latest.png");
    background-size: contain;
    background-position: top;
    background-repeat: no-repeat;
  }
  .headline-container {
    padding-top: 50px;
  }
}

.infobox {
  line-height: 2rem;
  color: $text-color-light;
}

img {
  max-width: 100%;
}
h3 {
  color: $pink;
}
.section {
  padding: 13rem 0 0 0;
  @media (max-width: 991px) {
    padding: 6rem 0 0 0;
  }
  @media (max-width: 576px) {
    padding: 1rem 0 0 0;
  }
}
.section.first {
  margin-top: 80px;
}

.icons:hover {
  background-color: #69afab !important;
}

.icons {
  height: 200px;
  width: 145px;
  text-align: center;

  display: block;
  @media (max-width: 576px) {
    margin: 5px;
    width: 108px;
    height: 136px;
  }
}

/* .icons-container div,
.icons-container a {
  text-align: center;
  width: 22%;
  padding-right: 0px;
  @media (max-width: 991px) {
    width: 22%;
  }
} */

.icons img {
  width: 100px;
  height: 100px;
  margin-top: 0px;

  @media (min-width: 576px) {
    margin-top: 27px;
  }
}

.icons-container p {
  text-transform: uppercase;
  font-size: 1rem;
  @media (max-width: 576px) {
    font-size: 0.8rem !important;
  }
}
.icons-container i.material-icons {
  font-size: 35px;
  color: white;
  position: relative;
  border-radius: 50%;
  padding: 20px;
  margin: 3px;
  background-color: $green;
  vertical-align: middle;
  width: 75px;
  height: 75px;
  @media (max-width: 576px) {
    font-size: 2rem;
    width: 4rem;
    height: 4rem;
    padding: 1rem;
  }
}
.info .price-info {
  width: auto;
}
table.register {
  width: 100%;
  font-size: 0.8rem;
  border-collapse: collapse;
}
table.register th {
  text-align: center;
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
}
table.register {
  border-collapse: separate;
  border-spacing: 10px 5px;
}

table.register td {
  border: 3px solid #e6e6e6;
  padding: 20px;
  width: 20%;
  margin: 2px;
  text-align: center;
  @media (max-width: 576px) {
    font-size: 0.8rem;
    padding: 5px;
  }
}

table.register th {
  border: 3px solid #e6e6e6;

  padding: 20px;
  width: 20%;
  text-align: center;
  @media (max-width: 576px) {
    font-size: 0.8rem;
    padding: 5px;
  }
}
table.register th:first-child {
  border: 0px;
}
.small {
  font-size: 0.8rem;
}
.info .opening-info {
  padding-bottom: 10px;
  width: auto;
  color: $text-color-light;
}

.group-one,
.group-two,
.group-three {
  vertical-align: top;
  display: inline-block;
  @media (max-width: 991px) {
    display: block !important;
  }
}
.group-one h5,
.group-two h5,
.group-three h5 {
  padding: 0 0 0 10px;
}
.group-one p,
.group-two p,
.group-three p {
  padding: 0 0 0 10px;
  margin: 0;
}
.group-one i,
.group-two i,
.group-three i {
  display: inline-block;
  font-size: 55px;
}
.group-two i {
  color: $orange;
}
.group-three i {
  color: $red;
}
.map-region,
.strange-o {
  max-width: 100%;
}
.charger i {
  font-size: 70px;
  vertical-align: middle;
}
.rotate-90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.video-container {
  position: relative;
  width: 100%;
  height: 0px;
  padding-bottom: 56.25%;
}

.video-container iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.person-icon {
  max-width: 60px;
}

.rectangle-red,
.rectangle-green,
.rectangle-red-short,
.rectangle-green-short {
  mix-blend-mode: color !important;
  position: absolute;
}

#red-1 {
  bottom: 5%;
}
#red-2 {
  top: 7%;
  mix-blend-mode: difference;
  z-index: 0;
}
#red-3 {
  top: 29%;
  mix-blend-mode: difference;
}
#red-4 {
  top: 49%;
  mix-blend-mode: difference;
  z-index: 0;
}
#red-5 {
  position: absolute;
  top: 67%;
  right: 0;
  mix-blend-mode: difference;
  z-index: 0;
}
#red-6 {
  top: 77.5%;
  mix-blend-mode: difference;
  z-index: 0;
}
#green-1 {
  bottom: 53%;
  right: 0%;
}
#green-2 {
  bottom: 89%;
  right: 0;
  z-index: 0;
}
#green-3 {
  bottom: 77%;
  right: 0;
  max-width: 80%;
  z-index: 0;
}
#green-4 {
  bottom: 60.5%;
  max-width: 80%;
  z-index: 1;
}
#green-5 {
  bottom: 55%;
  max-width: 80%;
  right: 0;
  z-index: 0;
}
#green-6 {
  bottom: 26%;
  max-width: 80%;
  right: 0;
  z-index: 0;
}

#green-7 {
  bottom: 18%;
  max-width: 80%;
  z-index: 0;
}
#green-8 {
  bottom: 13%;
  z-index: 0;
}

#white-1 {
  position: absolute;
  bottom: 91.5%;
  left: 5%;
}
#white-2 {
  position: absolute;
  bottom: 89.8%;
  left: 1%;
  z-index: 99;
}

#white-3 {
  position: absolute;
  bottom: 91%;
  z-index: 99;
  right: 5%;
}
#white-4 {
  position: absolute;
  bottom: 72%;
  z-index: 99;
  right: 5%;
}
#white-5 {
  position: absolute;
  bottom: 77%;
  z-index: 99;
  right: 5%;
}
#white-6 {
  position: absolute;
  bottom: 68%;
  z-index: 0;
  right: 14%;
}
#white-7 {
  position: absolute;
  bottom: 70.5%;
  z-index: 99;
  right: 0%;
}
#white-8 {
  position: absolute;

  bottom: 47.5%;
  left: 7%;
  z-index: 99;
  left: 5%;
}

#white-9 {
  position: absolute;

  bottom: 45.5%;
  left: 6%;
  z-index: 99;
  left: 2%;
}
#white-10 {
  position: absolute;
  bottom: 43.5%;
  left: 6%;
  z-index: 99;
  left: 0%;
}
#white-11 {
  position: absolute;
  bottom: 16%;
  right: 4%;
  z-index: 99;
}
#white-12 {
  position: absolute;
  bottom: 15%;
  right: 4%;
  z-index: 99;
}
#white-13 {
  position: absolute;
  bottom: 12%;
  left: 6%;
  z-index: 99;
}

@media screen and (max-width: 500px) {
  #red-1 {
    position: absolute;
    bottom: 50%;
  }
  #green-1 {
    position: absolute;
    bottom: 48%;
    right: 0%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue